import { render, staticRenderFns } from "./editNoteBox.vue?vue&type=template&id=625c795f&scoped=true"
import script from "./editNoteBox.vue?vue&type=script&lang=js"
export * from "./editNoteBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c795f",
  null
  
)

export default component.exports